<template>
    <div class="economy">

        <box-helper
            headline="Økonomi"
            identifier="economy"
        />

        <div class="container section">
            <title-block headline="<b>Økonomi</b>" class="mb-xl" position="center">
                <p slot="text">
                    Ét samlet økonomisk overblik over din virksomhed
                </p>
            </title-block>

            <view-toggle
                operationsName="Drift"
                operationsLink="EconomyOperations"
                learningName="Økonomi"
                learningLink="EconomyLearning"
                v-if="$route.name === 'EconomyOperations' && $auth.user().roles[0].name !== 'department-responsible'"
            />

            <router-view />
            
        </div>
    </div>
</template>

<script>

export default {
    data () {
        return {
            showHelper: false,
            selectedTable: 'KeyFigures',
            sidebarMenuItems: [
                {
                    name: 'Nøgletal',
                    tableName: 'KeyFigures'
                }
            ]
        }
    },
    computed: {},
    methods: {
        onRowClick (params) {
            console.log(params)
        },
        rowStyleClassFn (row) {
            return row.age > 18 ? 'green' : 'red'
        },
        updateCount (tableName, event) {
            this.counts[tableName] = event
        }
    }
}
</script>



// WEBPACK FOOTER //
// economy.vue?2807d369